import React from 'react';
import AppBar from 'material-ui/AppBar';

const NavBar = () => 
    <AppBar title="PixaBay Image Finder" />


export default NavBar;